import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Props, State, LegislationsOptionValue, LegislationsQuickFilter } from "./interfaces";
import { QuickFilterOption } from "../../../reusable-components/QuickFilter/interfaces";
import QuickFilter from "../../../reusable-components/QuickFilter/QuickFilter";

export const LegislationsQuickfilter = <Q extends LegislationsQuickFilter>({
  quickFilters,
  handleChangeQuickFilters,
  allLegislationsOption,
  isMultiSelect,
  legislations,
}: Props<Q>) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.legislations"; // tRP - translation root path

  const [options, setOptions] = useState<State>({
    customOptions: [
      ...(allLegislationsOption
        ? [
            {
              name: t(`${tRP}.all_legislations`),
              value: { legislationsIds: [] },
            },
          ]
        : []),
    ],
    computedOptions: [],
  });

  useEffect(() => {
    if (legislations) {
      const newOptions: QuickFilterOption<LegislationsOptionValue>[] = legislations.map(({ name, code, id }) => ({
        name,
        value: { legislationsIds: [id] },
        code,
      }));

      setOptions((state) => ({ ...state, computedOptions: newOptions }));
    }
  }, [legislations]);

  return (
    <QuickFilter
      options={[...options.customOptions, ...options.computedOptions]}
      quickFilters={quickFilters}
      quickFilter="legislations"
      handleChangeQuickFilter={handleChangeQuickFilters}
      shrinkedLabel={t(`${tRP}.shrinked_label`)}
      isMultiSelect={isMultiSelect}
      multiSelectField="legislationsIds"
    />
  );
};
